<template>
  <BaseModule
    v-bind="$props"
    class="embed-google-maps"
    data-module="google-maps"
  >
    <CustomHTML
      :html="embedCode"
      v-bind="$props"
    />
  </BaseModule>
</template>

<script>
import base from '@/mixins/base';
import BaseModule from './generic/BaseModule.vue';
import CustomHTML from './CustomHTML.vue';

export default {
  name: 'EmbedGoogleMaps',
  components: {
    BaseModule,
    CustomHTML,
  },
  mixins: [base],
  inheritAttrs: false,
  props: {
    ...BaseModule.props,
    linkMaps: {
      type: String,
      default: '',
    },
  },
  computed: {
    embedCode() {
      let embedLink = '';
      if (this.linkMaps !== undefined) {
        if (this.linkMaps.includes('mid=')) {
          let address = this.linkMaps.split('mid=');
          address = address[1].split('&');

          embedLink = `https://www.google.com/maps/d/u/0/embed?mid=${address[0]}`;
        }
      }

      const embedCode = `<iframe src="${embedLink}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" style="overflow:hidden;height:100%;width:100%" height="auto" width="100%"></iframe>`;
      return embedLink !== '' ? embedCode : '';
    },
  },
  metadata: {
    extends: BaseModule.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'map',
            label: 'Mapa',
            fields: [
              {
                name: 'linkMaps',
                type: 'ShortText',
                label: 'Link do Google Maps',
                helpText:
                  '<a target="_blank" href="https://docs.google.com/document/d/1CbUGiPuu8bGFvXAP0BnrtHHDy6bzolgGJMEqeCxMtq8/edit"> Saiba mais </a>',
                validation: {
                  presence: {
                    allowEmpty: false,
                    message: 'Preencha o campo Link do Google Maps',
                  },
                },
              },
            ],
          },
        ],
      },
      {
        name: 'appearance',
        groups: [
          {
            name: 'colors',
            toRemove: ['buttonColor', 'textColor', 'buttonTextColor'],
          },
        ],
        toRemove: ['fonts'],
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.embed-google-maps {
  ::v-deep {
    .html-content {
      max-width: 960px;
      height: 500px;
      margin-right: auto;
      margin-left: auto;
    }
  }
}
</style>
